export const theme = {
    radius: "18px",
    brand: "var(--brand-500)",
    brandDeep: "var(--brand-700)",
    fgStrong: "var(--text-900)",
    fgMuted: "var(--text-600)",
    bgSurface: "var(--surface-0)",
    bgElevated: "var(--surface-1)",
    bgPanel: "var(--surface-2)",
    bgControl: "var(--control-bg)",
    bgControlMuted: "var(--control-muted-bg)",
    bgChip: "var(--chip-bg)",
    bgItemActive: "var(--item-active-bg)",
    bgSelectionActive: "var(--selection-active-bg)",
    borderSoft: "var(--line-200)",
    borderStrong: "var(--line-300)",
    shadowSoft: "var(--shadow-soft)",
};
